import React, { useEffect, useState } from "react";
import { Box, Typography, Grid } from "@mui/material";

const Counter = ({ endValue, label }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const end = endValue;
    const duration = 2000;
    const incrementTime = Math.abs(Math.floor(duration / end));

    const timer = setInterval(() => {
      start += 1;
      setCount(start);
      if (start === end) clearInterval(timer);
    }, incrementTime);

    return () => clearInterval(timer);
  }, [endValue]);

  return (
    <Box textAlign="center" sx={{ padding: { xs: 1, sm: 2 } }}>
      <Typography
        variant="h3"
        className="numeros"
        sx={{ fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" } }}
      >
        {count}+
      </Typography>
      <Typography
        variant="h6"
        className="label-contador"
        sx={{ fontWeight:"300"  }}
      >
        {label}
      </Typography>
    </Box>
  );
};

const CountersSection = () => {
  return (
    <Box sx={{ padding: { xs: 2, sm: 4 }, marginX: { xs: 2, sm: 4, md: 0 } }}>
      <Grid
        container
        spacing={{ xs: 2, sm: 3 }}
        justifyContent="center"
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "1fr 1fr 1fr ",
            md: "1fr 1fr 1fr ",
          },
          gap: "2em",
        }}
      >
        <Grid item>
          <Counter endValue={100} label="Clientes satisfechos" />
        </Grid>
        <Grid item>
          <Counter endValue={100} label="Proyectos realizados" />
        </Grid>
        <Grid item>
          <Counter endValue={5} label="Años de experiencia" />
        </Grid>
      </Grid>
    </Box>
  );
};

export default CountersSection;
